<template>
	<v-btn
    :disabled = "!apps || !apps.length || apps.length !== 1"
	  color = "blue-grey"
    class = "nlp-nav-btn mx-0"
    style="border-radius: 0"
    small
    outline
    @click="handleClick">
	  <v-icon>
      north
	  </v-icon>
	  Export
	</v-btn>
</template>

<script>
export default {

  name: 'ExportApp',
  props: {
    apps: {
      type: Array,
      required: null
    }
  },
  data () {
    return {
    	
    }
  },
  computed: {

  },
  methods: {
  	handleClick() {
      if(!this.apps || !this.apps.length) return
      this.exportSelectedApps(this.apps)
  	},
    async exportSelectedApps(apps = this.apps) {
      try {
        this.$store.dispatch('setLoader', true)
        let i
        for(i = 0; i < apps.length; i += 1) {
          await this.exportSingleApp(apps[i])
        }
        this.$store.dispatch('setSnackbar', {
          text: `Exported`,
          color: 'success'
        })
        this.$store.dispatch('setLoader', false)
      } catch (err) {
        this.$store.dispatch('setLoader', false)
        this.$store.dispatch('setErrorMessage', (err && err.response && err.response.data && err.response.data.error) ? err.response.data.error : true)
      }
    },
    async exportSingleApp(app) {
      try {
        const response = await this.$http_nlp.get(`/apps/${app.id}/export`)
        this.downloadObjectAsJson(response.data.data, `Botter NLP App - ${app.name} - ${this.$moment().format('D/M hh:mm')}`)
        return true
      } catch (err) {
        throw err
        return false
      }
    },
    downloadObjectAsJson(exportObj, exportName){
      let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
      let downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.setAttribute("href",     dataStr);
      downloadAnchorNode.setAttribute("download", exportName + ".botter.json");
      document.body.appendChild(downloadAnchorNode); // required for firefox
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
    }
  }
}
</script>

<style lang="css" scoped>
</style>